/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frost_Free_Auto_HelpInputs */



/**
* | output |
* | --- |
* | "In Auto mode, the network goes into frost free when all the rooms associated with the thermostatic heads of this network are in frost free." |
*
* @param {Frost_Free_Auto_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const frost_free_auto_help = /** @type {((inputs?: Frost_Free_Auto_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frost_Free_Auto_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("In Auto mode, the network goes into frost free when all the rooms associated with the thermostatic heads of this network are in frost free.")
	return /** @type {LocalizedString} */ ("En mode Auto, le réseau passe en hors-gel lorsque toutes les pièces associées aux têtes thermostatiques de ce réseau sont en hors-gel.")
});